import React, {useState} from "react"
import { Navbar } from "reactstrap"
import classnames from "classnames"
import NavbarBookmarks from "./NavbarBookmarks"
import NavbarUser from "./NavbarUser"
import userImg from "../../../assets/img/portrait/small/avatar-s-11.jpg"
import { FaRegListAlt, FaAward, FaColumns, FaClock } from "react-icons/fa"
import { ModalNotePad } from "../../../views/components/modal/ModalNotePad"
import { ModalPremium } from "../../../views/components/modal/ModalPremium"
import { ModalNoteColumns } from "../../../views/components/modal/ModalNoteColumns"
import { ModalTimeZone } from "../../../views/components/modal/ModalTimeZone"
import { ModalWhatsapp } from "../../../views/components/modal/ModalWhatsapp"
import { useSelector } from "react-redux"

let size = 20

const ThemeNavbar = props => {
  const colorsArr = [ "primary", "danger", "success", "info", "warning", "dark"]
  const navbarTypes = ["floating" , "static" , "sticky" , "hidden"]

  const [showModalNotePad, setShowModalNotePad] = useState(false)
  const [showModalPremium, setShowModalPremium] = useState(false)
  const [showModalNoteColumns, setShowModalNoteColumns] = useState(false)
  const [showModalTimeZone, setShowModalTimeZone] = useState(false)
  const [showModalWhatsapp, setShowModalWhatsapp] = useState(false)

  const profile = useSelector(state => state.auth.login.state.data.user.verifyLogin.idprofile)

  return (
    <React.Fragment>
      <div className="content-overlay" />
      <div className="header-navbar-shadow" />
      <Navbar
        className={classnames(
          "header-navbar navbar-expand-lg navbar navbar-with-menu navbar-shadow",
          {
            "navbar-light": props.navbarColor === "default" || !colorsArr.includes(props.navbarColor),
            "navbar-dark": colorsArr.includes(props.navbarColor),
            "bg-primary":
              props.navbarColor === "primary" && props.navbarType !== "static",
            "bg-danger":
              props.navbarColor === "danger" && props.navbarType !== "static",
            "bg-success":
              props.navbarColor === "success" && props.navbarType !== "static",
            "bg-info":
              props.navbarColor === "info" && props.navbarType !== "static",
            "bg-warning":
              props.navbarColor === "warning" && props.navbarType !== "static",
            "bg-dark":
              props.navbarColor === "dark" && props.navbarType !== "static",
            "d-none": props.navbarType === "hidden" && !props.horizontal,
            "floating-nav":
              (props.navbarType === "floating" && !props.horizontal) || (!navbarTypes.includes(props.navbarType) && !props.horizontal),
            "navbar-static-top":
              props.navbarType === "static" && !props.horizontal,
            "fixed-top": props.navbarType === "sticky" || props.horizontal,
            "scrolling": props.horizontal && props.scrolling

          }
        )}
      >
        <div className="navbar-wrapper">
          <div className="navbar-container content">
            <div
              className="navbar-collapse d-flex justify-content-between align-items-center"
              id="navbar-mobile"
            >
              <div className="bookmark-wrapper">
                {
                  profile !== 308 &&
                <FaAward title="premium" size={size} style={{cursor:'pointer'}} onClick={() => { setShowModalPremium(!showModalPremium) }} />
                }
                {"  "}
                {
                  profile !== 308 &&
                <FaRegListAlt title="My notes" size={size} style={{cursor:'pointer'}} onClick={() => { setShowModalNotePad(!showModalNotePad) }} />
                }
                {"  "}
                {
                  profile !== 308 &&
                <FaColumns title="My notes columns" size={size} style={{cursor:'pointer'}} onClick={() => { setShowModalNoteColumns(!showModalNoteColumns) }} />
                }
                {" "}
                {/* <FaClock title="Time zone" size={size} style={{cursor:'pointer'}} onClick={() => { setShowModalTimeZone(!showModalTimeZone) }} /> */}
                {" "}´
                {
                  profile !== 308 &&
                  <span className="badge badge-success" onClick={() => { setShowModalWhatsapp(!showModalWhatsapp) }} style={{cursor:'pointer', fontSize:'15pt', fontWeight:'bold', borderRadius:'15px', border: '1px solid #188c4e'}}>RECEPCIÓN DE FACTURAS</span>
                }
                {/* <FaWhatsapp title="Send Contactus via Email" size={size} style={{cursor:'pointer', color:'green'}} onClick={() => { setShowModalWhatsapp(!showModalWhatsapp) }} /> */}
                <NavbarBookmarks
                  sidebarVisibility={props.sidebarVisibility}
                  handleAppOverlay={props.handleAppOverlay}
                />
              </div>
              {props.horizontal ? (
                <div className="logo d-flex align-items-center">
                  <div className="brand-logo mr-50"></div>
                  <h2 className="text-primary brand-text mb-0">Vuexy</h2>
                </div>
              ) : null}
              <NavbarUser
                handleAppOverlay={props.handleAppOverlay}
                changeCurrentLang={props.changeCurrentLang}
                userName="John Doe"
                userImg={ userImg }
              />
            </div>
          </div>
        </div>
        {
          <>
          { showModalNotePad && <ModalNotePad showModal={showModalNotePad} setShowModal={setShowModalNotePad}  />}
          { showModalPremium && <ModalPremium showModal={showModalPremium} setShowModal={setShowModalPremium}  />}
          { showModalNoteColumns && <ModalNoteColumns showModal={showModalNoteColumns} setShowModal={setShowModalNoteColumns}  />}
          { showModalTimeZone && <ModalTimeZone showModal={showModalTimeZone} setShowModal={setShowModalTimeZone}  />}
          { showModalWhatsapp && <ModalWhatsapp showModal={showModalWhatsapp} setShowModal={setShowModalWhatsapp}  />}
          </>
        }
      </Navbar>
    </React.Fragment>
  )
}


export default ThemeNavbar
